import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=50b476c2&scoped=true"
import script from "./TagInput.vue?vue&type=script&lang=js"
export * from "./TagInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b476c2",
  null
  
)

export default component.exports